import { useCallback, useMemo, useSyncExternalStore } from "react";

export function useMatchMedia(mediaQuery = '(1025px > width)', initialState = false) {
  const matchmediaList = useMemo(
    () =>
      typeof window === "undefined" ? undefined : window.matchMedia(mediaQuery),
    [mediaQuery]
  );

  const subscribe = useCallback(
    (onStoreChange) => {
      matchmediaList.addEventListener("change", onStoreChange);
      return () => matchmediaList.removeEventListener("change", onStoreChange);
    },
    [matchmediaList]
  );

  return useSyncExternalStore(
    subscribe,
    () => matchmediaList.matches ?? initialState,
    () => initialState
  );
}
